import type { CodeCategoryRuleLike, Transaction } from "./finance.ts";
import { brandContext } from "./business-units.ts";

export function categoryOrigin(row: Transaction, rules: CodeCategoryRuleLike[]) {
  if (row.categoryRuleId && row.categoryAssignmentSource === "rule") return { kind: "description_rule" as const };
  if (row.category === "uncategorized") return { kind: "unassigned" as const };
  if (row.categoryAssignmentSource === "manual") return { kind: "manual" as const };
  const rule = rules.find((value) => value.automatic && value.uniqueCode === row.uniqueCode
    && value.direction === row.direction && value.brandContext === brandContext(row) && value.category === row.category);
  if (row.categoryAssignmentSource === "rule" && rule) return { kind: "rule" as const, rule };
  // Never invent a current rule for a legacy assignment or old learned result.
  return { kind: "unverified" as const };
}
